import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function minSelectedValidator(min = 1): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (Array.isArray(value) && value.length >= min) {
      return null;
    }

    return { minSelected: { required: min, actual: value?.length ?? 0 } };
  };
}
